import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M15 11h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 15h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 16h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 16 20 6-6-20A20 20 0 0 0 2 16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5.71 17.11a17.04 17.04 0 0 1 11.4-11.4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Pizza";
const Pizza = memo(themed(Icon));
export {
  Pizza
};
//# sourceMappingURL=pizza.js.map
